import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Users } from "lucide-react";
import { API } from "@/lib/api";

export default function TrustTicker() {
  const [count, setCount] = useState(null);

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        const res = await fetch(`${API}/stats/today-unlocks`);
        const j = await res.json();
        if (mounted) setCount(j.count ?? 0);
      } catch {}
    };
    load();
    const id = setInterval(load, 20000);
    return () => {
      mounted = false;
      clearInterval(id);
    };
  }, []);

  if (count === null || count === 0) return null;

  return (
    <div
      className="flex items-center justify-center gap-2 rounded-full border border-zinc-800 bg-zinc-950/70 px-4 py-2 text-[11px] uppercase tracking-[0.2em] text-zinc-400"
      data-testid="trust-ticker"
    >
      <span className="relative flex h-2 w-2">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#4ADE80] opacity-70" />
        <span className="relative inline-flex h-2 w-2 rounded-full bg-[#4ADE80]" />
      </span>
      <Users size={12} className="text-zinc-500" />
      <AnimatePresence mode="popLayout">
        <motion.span
          key={count}
          initial={{ y: 8, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -8, opacity: 0 }}
          className="font-mono-data font-bold text-[#4ADE80]"
        >
          {count}
        </motion.span>
      </AnimatePresence>
      <span>punter{count === 1 ? "" : "s"} unlocked today</span>
    </div>
  );
}
